"use client"

import * as React from "react"
import CMCoachForms from "./_components/CMCoachForms"
import CMCoachingCalendar from "./_components/CMCoachingCalendar"
import CMCoachNotifications from "./_components/CMCoachNotifications"
import CMContactPage from "./_components/CMContactPage"
import CMInbox from "./_components/CMInbox"
import CMIntroduction from "./_components/CMIntroduction"
import CMJoiningVideoSession from "./_components/CMJoiningVideoSession"
import CMNotebook from "./_components/CMNotebook"
import CMPasswordPersonalInfo from "./_components/CMPasswordPersonalInfo"
import CMPasswordPersonalInfoMobile from "./_components/CMPasswordPersonalInfoMobile"
import CMScheduling from "./_components/CMScheduling"
import CMSetupGuide from "./_components/CMSetupGuide"
import CMSetupGuideMobile from "./_components/CMSetupGuideMobile"
import CMTableOfContents from "./_components/CMTableOfContents"
import CMTechSupport from "./_components/CMTechSupport"
import { Button } from "../../components/ui/button"
import CMCoachNotificationsMobile from "./_components/CMCoachNotificationsMobile"
import CMSchedulingMobile from "./_components/CMSchedulingMobile"
import CMInboxMobile from "./_components/CMInboxMobile"
import CMJoiningVideoSessionMobile from "./_components/CMJoiningVideoSessionMobile"
import CMNotebookMobile from "./_components/CMNotebookMobile"
import CMCoachFormsMobile from "./_components/CMCoachFormsMobile"
import CMContactPageMobile from "./_components/CMContactPageMobile"
import CMCoachingCalendarMobile from "./_components/CMCoachingCalendarMobile"
import CMTechSupportMobile from "./_components/CMTechSupportMobile"
import CMTestimonials from "./_components/CMTestimonials"
import CMTestimonialsMobile from "./_components/CMTestimonialsMobile"
import ClientManualNav from "./_components/ClientManualNav"

export default function ClientManualPage() {
  const [isVisible, setIsVisible] = React.useState(false)
  const [view, setView] = React.useState<"desktop" | "mobile">("desktop")

  React.useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener("scroll", toggleVisibility)
    return () => window.removeEventListener("scroll", toggleVisibility)
  }, [])

  return (
    <>
      <ClientManualNav />
      <div className="max-w-5xl mx-auto px-6 py-12 text-gray-800">
        <CMIntroduction />
        <header className="text-center mb-6">
          <h1 className="text-3xl md:text-4xl font-bold text-blurple text-center mb-6">
            QUICK START
          </h1>
          <div className="flex flex-col md:flex-row justify-center gap-4 mb-8">
            <Button
              variant={view === "desktop" ? "default" : "outline"}
              className="w-full md:w-auto"
              onClick={() => setView("desktop")}
            >
              View Desktop Instructions
            </Button>
            <Button
              variant={view === "mobile" ? "default" : "outline"}
              className="w-full md:w-auto"
              onClick={() => setView("mobile")}
            >
              View Mobile Instructions
            </Button>
          </div>
        </header>

        <CMTableOfContents />
        {view === "desktop" ? (
          <>
            <CMSetupGuide />
            <CMPasswordPersonalInfo />
            <CMCoachNotifications />
            <CMInbox />
            <CMCoachingCalendar />
            <CMScheduling />
            <CMJoiningVideoSession />
            <CMContactPage />
            <CMNotebook />
            <CMCoachForms />
            <CMTestimonials />
            <CMTechSupport />
          </>
        ) : (
          <>
            <CMSetupGuideMobile />
            <CMPasswordPersonalInfoMobile />
            <CMCoachNotificationsMobile />
            <CMInboxMobile />
            <CMCoachingCalendarMobile />
            <CMSchedulingMobile />
            <CMJoiningVideoSessionMobile />
            <CMContactPageMobile />
            <CMNotebookMobile />
            <CMCoachFormsMobile />
            <CMTestimonialsMobile />
            <CMTechSupportMobile />
          </>
        )}
      </div>
    </>
  )
}
